export default "__VITE_ASSET__R_hH9nVr__"